import { render, staticRenderFns } from "./ServicepointsTable.vue?vue&type=template&id=56aa09cc&scoped=true"
import script from "./ServicepointsTable.vue?vue&type=script&lang=ts"
export * from "./ServicepointsTable.vue?vue&type=script&lang=ts"
import style0 from "./ServicepointsTable.vue?vue&type=style&index=0&id=56aa09cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aa09cc",
  null
  
)

export default component.exports